<ion-card>
  <ion-row>
    <ion-col size="12">
      <h2 class="textCenter">{{'Additional Details' | translate}}</h2>
    </ion-col>
    <!-- <ion-col size="12" sizeMd="4" class="padding4">
      <app-a-input [label]="trans.translate('Address')"
        [(variable)]="auth.loggedInEmployee.user.user_pd.permanent_address"></app-a-input>
    </ion-col> -->
    <ion-col size="12" sizeMd="4" class="padding4">
      <app-a-select [label]="trans.translate('Education')" [type]="'Object'" [value]="'value'"
        [(variable)]="auth.loggedInEmployee.user.user_pd.education"
        [objectList]="utilityService.educationObjectList"></app-a-select>
      <app-a-input *ngIf="auth.loggedInEmployee.user.user_pd.education=='Other'" [label]="'Other Education'"
        [(variable)]="auth.loggedInEmployee.user.user_pd.other_education"></app-a-input>
    </ion-col>
    <ion-col size="12" sizeMd="4" class="padding4">
      <app-a-select [label]="trans.translate('Occupation')" [(variable)]="auth.loggedInEmployee.user.user_pd.occupation"
        [objectList]="utilityService.occupationList"></app-a-select>
      <app-a-input *ngIf="auth.loggedInEmployee.user.user_pd.occupation=='Other'" [label]="'Other Occupation'"
        [(variable)]="auth.loggedInEmployee.user.user_pd.other_occupation"></app-a-input>
    </ion-col>
    <ion-col size="12" sizeMd="4" class="padding4">
      <app-a-select [label]="trans.translate('Profession')" [(variable)]="auth.loggedInEmployee.user.user_pd.profession"
        [objectList]="utilityService.professionList"></app-a-select>
      <app-a-input *ngIf="auth.loggedInEmployee.user.user_pd.profession=='Other'" [label]="'Other Profession'"
        [(variable)]="auth.loggedInEmployee.user.user_pd.other_profession"></app-a-input>
    </ion-col>
    <ion-col size="12" sizeMd="4" class="padding4">
      <app-a-input [label]="trans.translate('Department')"
        [(variable)]="auth.loggedInEmployee.user.user_pd.department"></app-a-input>
    </ion-col>
    <ion-col size="12" sizeMd="4" class="padding4" *ngIf="auth.business.category && !auth.loggedInEmployee.user.user_pd.sub_community">
      <app-a-select [label]="trans.translate('Sub Community/Gotra/Khap/Pur')"
         [(variable)]="auth.loggedInEmployee.user.user_pd.sub_community"
        [objectList]="auth.business.category"></app-a-select>
    </ion-col>

    <!-- <ion-col size="12" class="padding4">
      <app-a-input [label]="trans.translate('Expertise Offer, I want to help')"
        [(variable)]="auth.loggedInEmployee.user.user_pd.expertise_offer"></app-a-input>
    </ion-col>

    <ion-col size="12" class="padding4">
      <app-a-input [label]="trans.translate('I need help in ')"
        [(variable)]="auth.loggedInEmployee.user.user_pd.help_required"></app-a-input>
    </ion-col> -->

    <ion-col size="12" sizeMd="4" class="padding4">
      <ion-card class="padding5">
        <ion-row>
          <ion-col size="8" class="font1_2 bold textCenter">{{'Achievements / Posts' | translate}}</ion-col>
          <ion-col size="3">
            <ion-button (click)="clickAddAchievements(null)" size="small" color="success" fill="outline">
              Add New
            </ion-button>
          </ion-col>
        </ion-row>
        <div
          *ngIf="auth.loggedInEmployee.user.user_pd.achievement && auth.loggedInEmployee.user.user_pd.achievement.length>0">
          <div *ngFor="let item of auth.loggedInEmployee.user.user_pd.achievement">
            <ion-row *ngFor="let key of objectKeys(item)">
              <ion-col size="1" class="bold borderMedium" (click)="deleteAchievement(item)">
                <ion-icon name="close-circle" color="danger"></ion-icon>
              </ion-col>
              <ion-col size="4" class="bold borderMedium">{{key}}</ion-col>
              <ion-col size="7" class="borderMedium" (click)="clickAddAchievements(item)">
                {{ item[key]}}
              </ion-col>
            </ion-row>
          </div>
        </div>
      </ion-card>
    </ion-col>
  </ion-row>
</ion-card>